import React from "react";

import "./styles.scss";
import { PlayerTriko } from "../PlayerTriko/Index";
import arrowIn from "../../../assets/global/arrow-in.png";
import arrowOut from "../../../assets/global/arrow-out.png";
import goalIconWhite from "../../../assets/global/ball_white.png";
import goalIconRed from "../../../assets/global/ball_red.png";
import i18n from "i18next";


const PitchTacticsForBild = React.forwardRef((props, ref) => {
    const {
        id,
        formation = "442",
        pitch = null,
        teamId = null,
        side = "home",
        lines = {},
        lineup = [],
        allPlayerMapping = {}
    } = props;

    const lng = i18n?.language;
    const className = props.className || "";
    const linesLen = Object.keys(lines).length;
    const arrayLines = Object.values(lines).reverse();
    return (
        <div id={id} ref={ref} className={`comp-pitch-tactics ${className}`}>
            <div className={`formation-block f-${formation} ft-${linesLen}`}>
                {pitch && (
                    <div className={`lineup-pitch`}>
                        <img src={pitch} />
                    </div>
                )}
                {arrayLines &&
                    arrayLines?.map((line, lineIndex) => {
                        return (
                            <div
                                key={`line-${++lineIndex}`}
                                className={`line line-${++lineIndex}`}
                            >
                                {line?.slice()?.reverse()?.map((p) => {
                                    const player = lineup?.find((l) => l?.person?.id === p?.person?.id);
                                    let shirtNumber = player?.shirtnumber;
                                    if (!shirtNumber && allPlayerMapping) {
                                        const mappedPlayer = allPlayerMapping[player?.person?.id]
                                        shirtNumber = mappedPlayer?.heimPlayer?.shirtnumber;
                                    }
                                    return (
                                        <div
                                            key={`p-${player?.person?.id}`}
                                            className={`lineup-player fp-${shirtNumber}`}
                                        >
                                            <div className={"shirt-number"}>{shirtNumber}</div>
                                            <PlayerTriko
                                                className={"left-player"}
                                                player={{
                                                    ...player,
                                                    shirtNumber: shirtNumber
                                                }}
                                                teamId={teamId}
                                                side={side}
                                                bgColor={"#FFFFFF"}
                                            />
                                            <div className={"player-name"}>
                                                {player?.person?.surname}
                                                {/* {isCaptain ? (lng === "de" ? "(K)" : "(C)") : ""} */}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
});

export default PitchTacticsForBild;
